import { Controller } from '@hotwired/stimulus'

// Writes the picked FinFolio label's Model.ID into the hidden finfolio_id field
// so the server can verify it. Clears the ID when the value is free-typed (not a
// known label), so the server falls back to a DisplayName lookup. Listens for the
// bubbling `tom-select:change` event from the combo box inside this wrapper.
export default class FinfolioModelIdController extends Controller<HTMLElement> {
  static targets = ['field']
  static values = { map: Object }

  declare readonly fieldTarget: HTMLInputElement
  declare readonly mapValue: Record<string, string>

  sync(event: CustomEvent<{ value: string }>) {
    const label = event.detail.value
    this.fieldTarget.value = this.mapValue[label] ?? ''
  }
}
